import { configGenericColumnDatable } from '../common/configGenericColumnDatatable'

export const concatObjectConfigDatatable = (objectA) => {
  const objectConcat = Object.assign(objectA, configGenericColumnDatable);
  return objectConcat;
}
